// extracted by mini-css-extract-plugin
module.exports = {"list":"Itemsss_list__2TkOA","card":"Itemsss_card___C2ew","loader":"Itemsss_loader__2ZyuD"};